<!-- 创建时间2023/07/04 16:58:29 -->
<!-- 创建人：Zhao bing bing -->
<!-- 组件描述： -->
<template>
  <div>
    <div>{{ $t('pc_kng_mark_btn_point_time'/** 时间点 */) }}</div>
    <form-point-time class="mt8" v-model="form.time" :insert-disabled="insertDisabled"/>
    <div class="mt24">{{ $t('pc_biz_udp_lbl_description'/** 描述 */) }}</div>
    <yxt-input
      class="mt8"
      type="textarea"
      :rows="2"
      :placeholder="$t('pc_kng_mark_msg_key_desc'/** 请输入关键帧描述 */)"
      maxlength="50"
      show-word-limit
      v-model="form.desc"/>          
  </div>
</template>

<script>
import formPointTime from './form-point-time.vue';
export default {
  name: 'form-point-form',
  components: {
    formPointTime
  },
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    insertDisabled: {
      type: Boolean,
      default: false
    },
    insertHidden: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  }
};
</script>